import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleCard from "@/components/feature/ArticleCard";
import SEOHead from "@/components/feature/SEOHead";
import { articles, categories, getHotArticles, getNewArticles } from "@/mocks/articles";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  const hotArticles = getHotArticles();
  const newArticles = getNewArticles();
  const featuredArticle = articles[0];
  const secondaryFeatured = articles.slice(1, 4);

  const heroBgImage = "https://readdy.ai/api/search-image?query=abstract%20warm%20gradient%20background%20with%20red%20and%20orange%20tones%20subtle%20geometric%20patterns%20modern%20entertainment%20news%20website%20hero%20design%20dark%20overlay%20ready%20artistic%20stylish%20atmosphere%20dramatic%20lighting%20cinematic%20mood%20editorial%20design%20concept&width=1600&height=800&seq=home-hero-bg-01&orientation=landscape";

  return (
    <>
      <SEOHead
        title="51吃瓜官网 - 51吃瓜爆料与51吃瓜黑料 | 最新娱乐八卦爆料曝光"
        description="51吃瓜官网提供最新娱乐八卦、明星丑闻、社会热点等爆料黑料内容，快速获取51吃瓜爆料网与51吃瓜黑料网的真实劲爆图文视频信息。吃瓜第一站，爆料不停歇！"
        keywords="51吃瓜官网,51吃瓜爆料,51吃瓜黑料,51吃瓜黑料网,51吃瓜爆料网,最新黑料,娱乐八卦爆料,黑料曝光,51吃瓜今日黑料"
        canonicalUrl="https://51chigua.com"
        schemaData={[
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "51吃瓜官网首页",
            description: "最新娱乐八卦爆料平台首页",
            url: "https://51chigua.com",
          },
        ]}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
          <img
            src={heroBgImage}
            alt=""
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-primary-900/30 via-transparent to-transparent"></div>

          <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-10">
            <div className="flex flex-col lg:flex-row gap-8">
              {/* Featured Article */}
              <div className="lg:w-7/12">
                <Link
                  to={`/article/${featuredArticle.id}`}
                  className="group block relative w-full h-[380px] md:h-[460px] rounded-xl overflow-hidden cursor-pointer"
                >
                  <img
                    src={featuredArticle.coverImage}
                    alt={featuredArticle.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                    <div className="flex items-center gap-2 mb-3 flex-wrap">
                      <span className="px-3 py-1 bg-primary-500 text-white text-xs font-medium rounded-full">
                        {featuredArticle.category}
                      </span>
                      <span className="px-2 py-1 bg-accent-500 text-white text-xs font-medium rounded-full flex items-center gap-1">
                        <i className="ri-fire-line text-xs"></i>热门
                      </span>
                      <span className="px-2 py-1 bg-white/20 backdrop-blur-sm text-white text-xs rounded-full flex items-center gap-1">
                        <i className="ri-flashlight-line text-xs"></i>最新
                      </span>
                    </div>
                    <h1 className="font-heading text-xl md:text-3xl font-bold text-white mb-2 group-hover:text-primary-300 transition-colors line-clamp-2">
                      {featuredArticle.title}
                    </h1>
                    <p className="text-sm text-white/70 line-clamp-2 mb-3 max-w-xl">{featuredArticle.excerpt}</p>
                    <div className="flex items-center gap-4 text-xs text-white/50">
                      <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{(featuredArticle.views / 10000).toFixed(1)}万阅读</span>
                      <span className="flex items-center gap-1"><i className="ri-time-line"></i>{featuredArticle.publishDate}</span>
                      <span className="flex items-center gap-1"><i className="ri-user-line"></i>{featuredArticle.author}</span>
                    </div>
                  </div>
                </Link>
              </div>

              {/* Secondary Articles */}
              <div className="lg:w-5/12 flex flex-col gap-3">
                {secondaryFeatured.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.id}`}
                    className="group flex gap-3 p-3 rounded-xl bg-white/10 backdrop-blur-sm hover:bg-white/20 transition-all duration-300 border border-white/10 cursor-pointer"
                  >
                    <div className="w-24 h-16 md:w-28 md:h-20 flex-shrink-0 rounded-lg overflow-hidden">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="flex flex-col justify-between min-w-0 flex-1">
                      <h3 className="text-sm font-medium text-white group-hover:text-primary-300 transition-colors line-clamp-2 leading-snug">
                        {article.title}
                      </h3>
                      <div className="flex items-center gap-2 text-xs text-white/50">
                        <span className="text-primary-300 font-medium">{article.category}</span>
                        <span>{article.publishDate}</span>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="bg-background-50 border-b border-background-200/70 sticky top-16 z-40">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-1 py-3 overflow-x-auto scrollbar-hide">
              <Link
                to="/"
                className="px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-full whitespace-nowrap flex items-center gap-1"
              >
                <i className="ri-home-line text-sm"></i>全部
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-2 text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 rounded-full whitespace-nowrap transition-colors"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Articles Grid */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  <i className="ri-fire-line text-primary-500 mr-2"></i>热门爆料
                </h2>
              </div>
              <Link
                to="/category/mingxing-bagua"
                className="text-sm text-foreground-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {hotArticles.slice(0, 6).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* Latest News */}
        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                  <i className="ri-flashlight-line text-accent-500 mr-2"></i>最新黑料
                </h2>
              </div>
              <Link
                to="/category/shehui-redian"
                className="text-sm text-foreground-500 hover:text-accent-600 transition-colors flex items-center gap-1"
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {newArticles.slice(0, 4).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
              {articles.filter((a) => !a.isNew && !a.isHot).slice(0, 4).map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* Trending Ranking */}
        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-8/12">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-1 h-6 bg-secondary-500 rounded-full"></div>
                  <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
                    <i className="ri-bar-chart-line text-secondary-500 mr-2"></i>24小时热榜
                  </h2>
                </div>
                <div className="flex flex-col gap-0">
                  {articles.slice(0, 8).map((article, index) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.id}`}
                      className="group flex items-center gap-4 py-3.5 border-b border-background-200/70 last:border-0 hover:bg-background-100/50 px-3 rounded-lg transition-colors cursor-pointer"
                    >
                      <span
                        className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                          index < 3
                            ? "bg-primary-500 text-white"
                            : "bg-background-200 text-foreground-500"
                        }`}
                      >
                        {index + 1}
                      </span>
                      <div className="flex-1 min-w-0">
                        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                          {article.title}
                        </h3>
                      </div>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{article.publishDate}</span>
                    </Link>
                  ))}
                </div>
              </div>

              {/* Sidebar */}
              <div className="lg:w-4/12">
                <div className="bg-background-100 rounded-xl p-5 border border-background-200/70 sticky top-24">
                  <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">热门标签</h3>
                  <div className="flex flex-wrap gap-2">
                    {["顶流男星", "税务问题", "网红翻车", "综艺冲突", "学历造假", "明星离婚", "人设崩塌", "带货翻车", "性骚扰", "富二代"].map((tag) => (
                      <span
                        key={tag}
                        className="px-3 py-1.5 bg-background-50 text-sm text-foreground-600 rounded-full border border-background-200/70 hover:border-primary-300 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>

                  <div className="mt-6 pt-5 border-t border-background-200/70">
                    <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4">关于51吃瓜</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                      51吃瓜官网是全网最火爆的娱乐八卦爆料平台。我们致力于为吃瓜群众提供最新、最全、最真实的明星黑料、网红翻车、社会热点等劲爆内容。吃瓜爆料第一站，每天更新不停歇！
                    </p>
                    <Link
                      to="/about"
                      className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
                    >
                      了解更多 <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}